import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import {
  SignableOrganizationPerCountry,
  taxAgencyOrgsTexts,
} from 'modules/expenses/hooks/useTaxAgencyHomologations'

interface LegalComplianceAccessProps {
  enabled: boolean
  organization: SignableOrganizationPerCountry
  hasTermsSigned: boolean
}

const buildRouteToFiles = (
  navigation: Navigation<NavigationPaths>,
  organization: SignableOrganizationPerCountry
): string | undefined => {
  const routesByOrg = {
    aeat: navigation.settings.expenses.signedInvoices.fullPath(),
    ade: navigation.settings.expenses.italyHomologation.fullPath(),
    urssaf: undefined,
  }
  return routesByOrg[organization]
}

const LegalComplianceAccessItem = ({
  enabled,
  organization,
  hasTermsSigned,
}: LegalComplianceAccessProps) => {
  const { navigation } = useNavigation()
  const routeToFiles = buildRouteToFiles(navigation, organization)

  return (
    <Box width="full" flexDirection="row" justifyContent="center" alignItems="flexStart" gap="s8">
      {hasTermsSigned ? (
        <Icon.Medium icon="check-circle" color="grey800" />
      ) : (
        <Icon.Medium icon="alert-circle-line" color="grey800" />
      )}
      <Box flexGrow gap="s4">
        <Text.Normal weight="medium" size="300" color="grey1000">
          {taxAgencyOrgsTexts(organization).termsTitle}
        </Text.Normal>
        <Text.Normal weight="normal" size="200" color="grey700">
          {hasTermsSigned
            ? taxAgencyOrgsTexts(organization).documentsDescription
            : taxAgencyOrgsTexts(organization).termsDescription}
        </Text.Normal>
      </Box>
      {routeToFiles && (
        <Button.Router
          to={routeToFiles}
          type="secondary"
          disabled={!enabled}
          iconName="arrow-right"
        />
      )}
    </Box>
  )
}

export default LegalComplianceAccessItem
